<template>
    <div class="c-search b-form__item b-form__item b-form__item--simple" data-show-container="course">
        <input
                class="b-form__input"
                placeholder="Я ищу курс..."
                v-model.lazy="searchModel"
                v-throttle="300">
        <div
                class="btn btn--contrast ripple ripple--contrast"
                v-if="this.urlDate.search"
                @click="clearSearch"
        >Очистить</div>
    </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import throttle from '@/utils/throttle/index'

  export default {
    name: "ScheduleSearch",
    directives: {
      throttle
    },
    computed: {
      ...mapState([
        'filterSearch',
        'urlDate'
      ]),
      searchModel: {
        get() {
          return this.filterSearch
        },
        set(val) {
          this.setFilterSearchURL(val)
        }
      }
    },
    created() {
      if (this.urlDate.search) this.setFilterSearchURL(decodeURI(this.urlDate.search));
    },
    methods: {
      ...mapActions([
        'setFilterSearchURL'
      ]),
        clearSearch() {
            this.setFilterSearchURL('')
        }
    }
  }
</script>
